import { render } from "./EditCuponForm.vue?vue&type=template&id=89324b08&scoped=true"
import script from "./EditCuponForm.vue?vue&type=script&lang=js"
export * from "./EditCuponForm.vue?vue&type=script&lang=js"

import "./EditCuponForm.vue?vue&type=style&index=0&id=89324b08&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89324b08"]])

export default __exports__